import {Selection} from 'd3';

import getTestProps from './getTestProps';
import DataTestAttrs from './shared/DataTestAttrs';

/**
 * Add data test attributes to a D3 selection.
 */
export default function addTestAttrsToD3Selection(
  selection: Selection<d3.BaseType, unknown, HTMLElement | SVGElement, unknown>,
  dataTestAttrs: DataTestAttrs
): void {
  for (const [key, val] of Object.entries(getTestProps(dataTestAttrs))) {
    selection.attr(key, val);
  }
}
